import { OpenLocationCode } from 'open-location-code';

/** Reference for short Plus Codes near the Cidadela */
export const BRAGANCA_REF = {
  lat: 41.80555,
  lng: -6.749,
};

const olc = new OpenLocationCode();

/**
 * Decode a Google Maps Plus Code to [lat, lng].
 * Accepts short ("R732+J4P"), short + place ("R732+J4P Bragança"),
 * or full codes ("8CHMR732+J4P").
 */
export function resolvePlusCode(plusCode, ref = BRAGANCA_REF) {
  if (!plusCode || typeof plusCode !== 'string') {
    throw new Error('Plus Code is required');
  }

  const codeOnly = plusCode.trim().split(/\s+/)[0].toUpperCase();

  if (!olc.isValid(codeOnly)) {
    throw new Error('Invalid Plus Code: ' + plusCode);
  }

  const fullCode = olc.isShort(codeOnly)
    ? olc.recoverNearest(codeOnly, ref.lat, ref.lng)
    : codeOnly;

  const area = olc.decode(fullCode);
  return [area.latitudeCenter, area.longitudeCenter];
}
